var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JobCard',{attrs:{"jobInfo":_vm.jobInfo2,"showStatus":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.optimizedResume}},[_vm._v("优化简历")])],1),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v(_vm._s(_vm.jobInfo2.reason))])])
}
var staticRenderFns = []

export { render, staticRenderFns }